import { Check, Crown } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";
import { packages, whatsappMessages, waLink } from "@/config/site";

export const Packages = () => (
  <section id="packages" data-testid="packages-section" className="relative bg-ivory py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="text-center max-w-2xl mx-auto">
        <Reveal className="flex justify-center"><Eyebrow>Packages</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl leading-tight text-charcoal">
            Curated tiers, fully
            <span className="italic text-maroon"> customizable.</span>
          </h2>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">
        {packages.map((p, i) => {
          const royal = p.highlight;
          return (
            <motion.div
              key={p.name}
              data-testid={`package-card-${p.name.replace(/\s+/g, "-").toLowerCase()}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className={`relative flex flex-col rounded-3xl p-8 transition-transform duration-500 ${
                royal
                  ? "bg-maroon lg:scale-105 shadow-2xl shadow-maroon/30"
                  : "bg-white border border-champagne/25 hover:-translate-y-2 hover:shadow-xl"
              }`}
            >
              {royal && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 flex items-center gap-1.5 rounded-full bg-champagne px-4 py-1 text-[11px] font-semibold uppercase tracking-wider text-charcoal">
                  <Crown className="h-3.5 w-3.5" strokeWidth={2} /> Signature
                </span>
              )}
              <h3 className={`font-display text-3xl ${royal ? "text-champagne" : "text-maroon"}`}>
                {p.name}
              </h3>
              <p className={`mt-3 text-xs uppercase tracking-wider ${royal ? "text-white/60" : "text-charcoal/50"}`}>
                Suitable for
              </p>
              <p className={`mt-1 text-sm ${royal ? "text-white/90" : "text-charcoal/80"}`}>
                {p.suitableFor}
              </p>

              <div className="my-6 h-px w-full bg-champagne/20" />

              <p className={`text-xs uppercase tracking-wider mb-3 ${royal ? "text-white/60" : "text-charcoal/50"}`}>
                Included Services
              </p>
              <ul className="space-y-2.5 flex-1">
                {p.included.map((it) => (
                  <li key={it} className="flex items-start gap-2.5 text-sm">
                    <Check className={`mt-0.5 h-4 w-4 shrink-0 ${royal ? "text-champagne" : "text-champagne"}`} strokeWidth={2} />
                    <span className={royal ? "text-white/85" : "text-charcoal/75"}>{it}</span>
                  </li>
                ))}
              </ul>

              <p className={`mt-6 text-xs italic ${royal ? "text-white/60" : "text-charcoal/50"}`}>
                Customization available
              </p>
              <a
                data-testid={`package-cta-${p.name.replace(/\s+/g, "-").toLowerCase()}`}
                href={waLink(whatsappMessages.packages[p.name])}
                target="_blank"
                rel="noopener noreferrer"
                className={`mt-4 block w-full rounded-full py-3 text-center text-sm font-medium transition-all duration-300 ${
                  royal
                    ? "bg-champagne text-charcoal hover:bg-white"
                    : "border border-maroon text-maroon hover:bg-maroon hover:text-white"
                }`}
              >
                Contact for Pricing
              </a>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
